export const applyBreakpoint = (bp: string, classes: string[]) => {
    return classes.map((c) => `${bp}:${c}`).join(" ");
};
